<app-header></app-header>
<app-navbar></app-navbar>
<div class="d-flex">
    <aside role="complementary" [attr.aria-label]="'asideDescription' | translate">
        <app-sidebar [items]="links"></app-sidebar>
    </aside>
    <main class="ps-5 w-100">
        <div class="row mb-3">
            <div class="text-end d-flex align-items-center col-12 mt-2 justify-content-between">
                <h2 class="mb-3 textformat">{{ 'sidebar.controlTypes' | translate }}</h2>
            </div>
        </div>
        @if (this.typeResponse.DiscountControlTypesDto && this.typeResponse.DiscountControlTypesDto.length >0) {
        <div>
            <fieldset>
                <table class="table text-center mt-2" [attr.aria-label]="'sidebar.controlTypes' | translate"
                    tabindex="0">
                    <thead>
                        <tr>
                            <th scope="col">{{ 'tariffRole.descripcion' | translate }}</th>
                            <th scope="col">{{ 'discount.controlValueType' | translate }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (type of this.typeResponse.DiscountControlTypesDto; track $index) {
                        <tr>
                            <td>
                                <span>{{ type.description }}</span>
                            </td>
                            <td>
                                <span *ngIf="type.controlValueType == 'NI'">{{ 'NI' | translate }}</span>
                                <span *ngIf="type.controlValueType == 'DA'">{{ 'DA' | translate }}</span>
                                <span *ngIf="type.controlValueType == 'NU'">{{ 'NU' | translate }}</span>
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
            </fieldset>

            <div class="mt-2" *ngIf="this.typeResponse.pageDto">
                <app-paginator [isStart]="this.typeResponse.pageDto.start" [isEnd]="this.typeResponse.pageDto.end"
                    [currentPage]="this.typeResponse.pageDto.currentPage" [totalPages]="this.typeResponse.pageDto.pages"
                    [numberRecord]="this.typeResponse.pageDto.records" [sizePage]="this.typeResponse.pageDto.pageSize">
                </app-paginator>
            </div>
        </div>
        }
    </main>
</div>